import { AnimatePresence, motion } from "framer-motion";

export const Tooltip = ({ isVisible, label }: { isVisible: boolean; label: string }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <div className="absolute">
      <AnimatePresence>
        <div className="relative inset-0">
          <motion.span
            initial={{ y: 0, opacity: 0 }}
            animate={{ y: -8, opacity: 1 }}
            exit={{ y: 0, opacity: 0 }}
            transition={{ ease: "easeInOut", duration: 0.5 }}
            style={{
              position: "absolute",
              top: "-32px",
              left: 0,
              zIndex: 30,
              borderRadius: "4px",
              background: "white",
              paddingLeft: "6px",
              paddingRight: "6px",
              paddingTop: "4px",
              paddingBottom: "4px",
              fontSize: "14px",
              fontWeight: 500,
              color: "rgb(107, 114, 128)",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
            }}
          >
            {label}
          </motion.span>
        </div>
      </AnimatePresence>
    </div>
  );
};
